var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"Status__Icon",attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({style:({color: _vm.corStatus})},on),[_vm._v("lens")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$tc(("status_entidade." + (_vm.tooltip.toLowerCase())), 1)))])])}
var staticRenderFns = []

export { render, staticRenderFns }